export const apiKey = "AIzaSyCZFdetiRmg_hniEBnxemmEVz0OxqBP--U";
export const authDomain = "calendar-scheduler-59025.firebaseapp.com";
export const projectId = "calendar-scheduler-59025";
export const storageBucket = "calendar-scheduler-59025.appspot.com";
export const messagingSenderId = "804975176064";
export const appId = "1:804975176064:web:00449ea12b17e60b76f965";
export const measurementId = "G-6LXFVHP9BJ";
